import { useEffect, useRef, useState } from 'react';
import { supabase } from '../../../lib/supabaseClient';
import '../../../styles/InstallerAdmin.css';

const STATUS_FA = {
  compliant: 'منطبق با ضوابط',
  non_compliant: 'مغایر با ضوابط',
  partially_compliant: 'تا حدی منطبق',
  insufficient_evidence: 'شواهد ناکافی',
};

// Lightweight verdict viewer for job-triggered and recent inspections. Polls
// the variant route until done (solo by default); reuses the existing
// inspection data shape without touching the heavy InspectionTab.
export default function JobInspectionModal({ inspectionId, variant = 'solo', onClose }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const timer = useRef(null);

  useEffect(() => {
    let cancelled = false;
    setData(null);
    setErr(null);
    const route = { full: '/api/inspection', fast: '/api/inspection-fast', solo: '/api/inspection-solo' }[variant];
    if (!route) { setErr('نوع بازرسی نامعتبر است.'); return undefined; }
    const poll = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        const res = await fetch(`${route}/${encodeURIComponent(inspectionId)}`, {
          headers: { Authorization: `Bearer ${session?.access_token}` },
        });
        const body = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (!res.ok) { setErr(body.error || 'خطا در خواندن نتیجهٔ بازرسی.'); return; }
        setData(body);
        if (body.status === 'running') timer.current = setTimeout(poll, 4000);
      } catch (e) { if (!cancelled) setErr('خواندن نتیجهٔ بازرسی ناموفق بود.'); }
    };
    poll();
    return () => { cancelled = true; clearTimeout(timer.current); };
  }, [inspectionId, variant]);

  const v = data?.verdict;
  const violations = Array.isArray(v?.violations) ? v.violations : [];

  return (
    <div className="iadmin">
      <div className="iadmin-overlay" onClick={onClose}>
        <div role="dialog" className="iadmin-modal" onClick={(e) => e.stopPropagation()}>
          <div className="iadmin-modal-head">
            <h3 className="iadmin-modal-title">نتیجهٔ بازرسی</h3>
            <button className="iadmin-x" onClick={onClose} aria-label="بستن">×</button>
          </div>
          <div className="iadmin-modal-body">
            {err && <div role="alert" className="iadmin-alert">{err}</div>}
            {!data && !err && <p className="iadmin-muted">در حال بارگذاری...</p>}
            {data?.status === 'running' && (
              <p className="iadmin-muted">بازرس در حال بررسیِ عکس‌هاست... این صفحه خودکار به‌روزرسانی می‌شود.</p>
            )}
            {data?.status === 'error' && (
              <div role="alert" className="iadmin-alert">{data.error_message || 'بازرسی با خطا مواجه شد.'}</div>
            )}
            {data?.status === 'done' && v && (
              <>
                <div className="iadmin-kv">
                  <span className="iadmin-kv-k">وضعیت کلی</span>
                  <span className="iadmin-kv-v">{STATUS_FA[v.overall_status] || v.overall_status || '-'}</span>
                </div>
                {v.summary && <p className="iadmin-muted" style={{ lineHeight: 1.7 }}>{v.summary}</p>}
                {v.final_action && (
                  <div className="iadmin-kv"><span className="iadmin-kv-k">اقدام نهایی</span><span className="iadmin-kv-v">{v.final_action}</span></div>
                )}
                {violations.length > 0 ? (
                  <div className="iadmin-list" style={{ marginTop: 10 }}>
                    {violations.map((viol, i) => (
                      <div key={i} className="iadmin-job" style={{ alignItems: 'stretch' }}>
                        <strong>{viol.title || viol.rule || viol.id || `مورد ${i + 1}`}</strong>
                        {(viol.description || viol.detail || viol.recommendation) && (
                          <span className="iadmin-muted">{viol.description || viol.detail || viol.recommendation}</span>
                        )}
                      </div>
                    ))}
                  </div>
                ) : <p className="iadmin-muted">موردِ تخلفی گزارش نشد.</p>}
              </>
            )}
            {data?.status === 'done' && !v && <p className="iadmin-muted">بازرسی تمام شد ولی وردیکتی ثبت نشد.</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
